import { Component, Inject, OnInit } from '@angular/core';
import { CalibrationAnnualPlan } from '../../../../model/calibration';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { SpinnerService } from '../../../../services/spinner.service';
import { TranslateService } from '@ngx-translate/core';
import { firstValueFrom, map, Subject, takeUntil } from 'rxjs';
import { SnackBarService } from '../../../../services/snackBar.service';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { CalibrationPlanEditManualSignReportDialogComponent } from '../calibration-plan-edit-manual-sign-report-dialog/calibration-plan-edit-manual-sign-report-dialog.component';
import { User } from '../../../../model/user';
import { UserService } from '../../../../services/user.service';
import { InternalEquipmentCustomFieldsService } from '../../../../services/internalEquipmentCustomFields.service';
import { InternalEquipmentCustomField } from '../../../../model/internalEquipmentCustomField';
import { ArrayUtils } from '../../../../utils/arrayUtils';

export interface DialogDataGenerateReport {
  calibrationPlan: CalibrationAnnualPlan;
  isSignature: boolean;
  hasCalibration: boolean;
  hasVerification: boolean;
}
@Component({
  selector: 'app-calibration-plan-edit-generate-report-dialog',
  templateUrl: './calibration-plan-edit-generate-report-dialog.component.html',
  styleUrl: './calibration-plan-edit-generate-report-dialog.component.scss',
  standalone: false
})
export class CalibrationPlanEditGenerateReportDialogComponent implements OnInit {
  cols: any[] = [];
  selectedCols: boolean = true;
  currentUser: User;
  private destroy$ = new Subject<void>();
  constructor(
    private userService: UserService,
    private internalEquipmentCustomFieldService: InternalEquipmentCustomFieldsService,
    public dialog: MatDialog,
    private spinnerService: SpinnerService,
    private translate: TranslateService,
    public snackBarService: SnackBarService,
    private dialogRef: MatDialogRef<CalibrationPlanEditGenerateReportDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogDataGenerateReport) {
    this.currentUser = this.userService.currentProfile;
  }

  ngOnInit(): void {

    this.cols.push({ name: this.translate.instant('common.reportType.identificative.cols'), col: 'identificative' });
    this.cols.push({ name: this.translate.instant('common.reportType.equipment.cols'), col: 'equipment' });
    this.cols.push({ name: this.translate.instant('common.reportType.group.cols'), col: 'group' });
    this.cols.push({ name: this.translate.instant('common.reportType.maker.cols'), col: 'maker' });
    this.cols.push({ name: this.translate.instant('common.reportType.model.cols'), col: 'model' });
    this.cols.push({ name: this.translate.instant('common.reportType.serieNum.cols'), col: 'serieNum' });
    this.cols.push({ name: this.translate.instant('common.reportType.location.cols'), col: 'location' });
    this.cols.push({ name: this.translate.instant('common.reportType.equipmentStatus.cols'), col: 'equipmentStatus' });
    this.cols.push({ name: this.translate.instant('common.reportType.calibrationCertificate.cols'), col: 'calibrationCertificate' });
    this.cols.push({ name: this.translate.instant('common.reportType.calibrationDate.cols'), col: 'calibrationDate' });
    this.cols.push({ name: this.translate.instant('common.reportType.expirationCalibrationDate.cols'), col: 'expirationCalibrationDate' });
    this.cols.push({ name: this.translate.instant('common.reportType.calibrationStatus.cols'), col: 'calibrationStatus' });
    this.cols.push({ name: this.translate.instant('common.reportType.verificationCertificate.cols'), col: 'verificationCertificate' });
    this.cols.push({ name: this.translate.instant('common.reportType.verificationDate.cols'), col: 'verificationDate' });
    this.cols.push({ name: this.translate.instant('common.reportType.expirationVerificationDate.cols'), col: 'expirationVerificationDate' });
    this.cols.push({ name: this.translate.instant('common.reportType.verificationStatus.cols'), col: 'verificationStatus' });
    this.cols.push({ name: this.translate.instant('common.reportType.maintenanceCertificate.cols'), col: 'maintenanceCertificate' });
    this.cols.push({ name: this.translate.instant('common.reportType.maintenanceDate.cols'), col: 'maintenanceDate' });
    this.cols.push({ name: this.translate.instant('common.reportType.expirationMaintenanceDate.cols'), col: 'expirationMaintenanceDate' });
    this.cols.push({ name: this.translate.instant('common.reportType.maintenanceStatus.cols'), col: 'maintenanceStatus' });
    this.cols.push({ name: this.translate.instant('common.reportType.qualificationCertificate.cols'), col: 'qualificationCertificate' });
    this.cols.push({ name: this.translate.instant('common.reportType.qualificationDate.cols'), col: 'qualificationDate' });
    this.cols.push({ name: this.translate.instant('common.reportType.expirationQualificationDate.cols'), col: 'expirationQualificationDate' });
    this.cols.push({ name: this.translate.instant('common.reportType.qualificationStatus.cols'), col: 'qualificationStatus' });
    this.cols.push({ name: this.translate.instant('common.reportType.characterizationCertificate.cols'), col: 'characterizationCertificate' });
    this.cols.push({ name: this.translate.instant('common.reportType.characterizationDate.cols'), col: 'characterizationDate' });
    this.cols.push({ name: this.translate.instant('common.reportType.expirationCharacterizationDate.cols'), col: 'expirationCharacterizationDate' });
    this.cols.push({ name: this.translate.instant('common.reportType.characterizationStatus.cols'), col: 'characterizationStatus' });

    this.cols.push({ name: this.translate.instant('common.reportType.calibrationRangeUse.cols'), col: 'calibrationRangeUse' });
    this.cols.push({ name: this.translate.instant('common.reportType.calibrationRangeEquipment.cols'), col: 'calibrationRangeEquipment' });
    this.cols.push({ name: this.translate.instant('common.reportType.calibrationResolution.cols'), col: 'calibrationResolution' });
    this.cols.push({ name: this.translate.instant('common.reportType.calibrationTolerence.cols'), col: 'calibrationTolerence' });
    this.cols.push({ name: this.translate.instant('common.reportType.calibrationFrequency.cols'), col: 'calibrationFrequency' });
    this.cols.push({ name: this.translate.instant('common.reportType.calibrationResponsible.cols'), col: 'calibrationResponsible' });
    this.cols.push({ name: this.translate.instant('common.reportType.calibrationSupplier.cols'), col: 'calibrationSupplier' });
    this.cols.push({ name: this.translate.instant('common.reportType.calibrationFee.cols'), col: 'calibrationFee' });      
    this.cols.push({ name: this.translate.instant('common.reportType.verificationRangeUse.cols'), col: 'verificationRangeUse' });
    this.cols.push({ name: this.translate.instant('common.reportType.verificationRangeEquipment.cols'), col: 'verificationRangeEquipment' });
    this.cols.push({ name: this.translate.instant('common.reportType.verificationResolution.cols'), col: 'verificationResolution' });
    this.cols.push({ name: this.translate.instant('common.reportType.verificationTolerence.cols'), col: 'verificationTolerence' });
    this.cols.push({ name: this.translate.instant('common.reportType.verificationFrequency.cols'), col: 'verificationFrequency' });
    this.cols.push({ name: this.translate.instant('common.reportType.verificationResponsible.cols'), col: 'verificationResponsible' });
    this.cols.push({ name: this.translate.instant('common.reportType.verificationSupplier.cols'), col: 'verificationSupplier' });
    this.cols.push({ name: this.translate.instant('common.reportType.verificationFee.cols'), col: 'verificationFee' }); 

    this.spinnerService.show();
    this.internalEquipmentCustomFieldService.findAll().pipe(
      map(res => {
        this.spinnerService.hide();

        if (res && res?.content) {
          const resCustom = res.content.map((e: InternalEquipmentCustomField) => ({ name: e.name, col: e.id }));
          if (ArrayUtils.isNotEmpty(resCustom)) {
            resCustom?.forEach(element => {
              this.cols.push(element);
            });
          }
        }

        if (!this.data.calibrationPlan.cols || this.data.calibrationPlan.cols.length === 0) {
          this.data.calibrationPlan.cols = this.cols.map(c => c.col);
        }

        this.selectedCols = this.cols.length === this.data.calibrationPlan.cols?.length;
      })
    ).subscribe();
  }

  onOkClick(): void {
    if (!this.data.calibrationPlan.cols || this.data.calibrationPlan.cols.length === 0) {
      this.snackBarService.sendError(this.translate.instant('common.reportType.identificative.cols.empty'));
    } else {
      this.data.calibrationPlan.type = 1;
      this.dialogRef.close(this.data.calibrationPlan);
    }
  }

  onNoClick(): void {
    this.dialogRef.close(null);
  }

  openDialogSigner() {
    if (!this.data.calibrationPlan.cols || this.data.calibrationPlan.cols.length === 0) {
      this.snackBarService.sendError(this.translate.instant('common.reportType.identificative.cols.empty'));
    } else {
      this.data.calibrationPlan.type = 2;
      this.dialogRef.close(this.data.calibrationPlan);
    }
  }

  onChangeOptionsCheck(event: MatCheckboxChange): void {
    const check = event.checked;
    if (check) {
      this.data.calibrationPlan.cols = this.cols.map(c => c.col);
    } else {
      this.data.calibrationPlan.cols = [];
    }
  }

  openSignManual(): void {
    const dialogRef = this.dialog.open(CalibrationPlanEditManualSignReportDialogComponent, {
      minWidth: '20%',
      maxHeight: '95vh',
      data: {
        calibrationPlan: this.data.calibrationPlan,
      }
    });

    dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe(res => {
      if (res) {
        this.data.calibrationPlan.type = res.type;
        this.dialogRef.close(this.data.calibrationPlan);
      }
    });
  }
  
  showSignBtn() {
    return this.currentUser.admin || this.currentUser.manager;
  }

  async getCustomsEquipment() {
    return await firstValueFrom(this.internalEquipmentCustomFieldService.findAll());
  }
}
